exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".form-password{padding-top:10px;padding-bottom:10px}.form-control.form-password-error,.form-control.form-password-error:focus{border:1px solid #dd0342}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/form/FormPassword/FormPassword.scss
 ** module id = 1243
 ** module chunks = 0
 **/